import wx from 'we-jssdk';
import 'whatwg-fetch';
import { pathInfo } from '../Router/pathList';

export async function getWxConfig(callback?: any, errorCallback?: any) {
  let appId;
  let timestamp;
  let nonceStr;
  let signature;
  const wechatUrl = '/api/official/mobile/getWXConfig';

  const params = {
    url: window.location.href.split('#')[0],
  };
  try {
    let configData = await fetch(wechatUrl, {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest', // FIXME: 使登录失效时不往 SSO 不跳转，临时方案
      },
      body: JSON.stringify(params),
      credentials: 'same-origin',
    });
    configData = await configData.json();
    // @ts-ignore
    configData = configData?.data;
    // @ts-ignore
    appId = configData?.appId;
    // @ts-ignore
    timestamp = configData?.timestamp;
    // @ts-ignore
    nonceStr = configData?.noncestr;
    // @ts-ignore
    signature = configData?.signature;
  } catch (e) {
    errorCallback && errorCallback(e);
    console.error(e.message);
  }
  wx.config({
    debug: false,
    appId,
    timestamp,
    nonceStr,
    signature,
    jsApiList: ['onMenuShareTimeline', 'onMenuShareAppMessage'],
  });

  wx.ready(() => {
    callback && callback();
  });
}

export function onMenuShareConfig(data, callback?) {
  wx.ready(() => {
    wx.onMenuShareAppMessage({
      title: data.title,
      link: data.link,
      imgUrl: data.imgUrl,
      desc: data.desc,
      success() {},
      trigger() {
        // 用户操作Menu中的按钮时关闭引导页面
        callback && callback(false);
      },
      fail() {},
    });
    wx.onMenuShareTimeline({
      title: data.title,
      link: data.link,
      imgUrl: data.imgUrl,
      desc: data.desc,
      success() {},
      trigger() {
        // 用户操作Menu中的按钮时关闭引导页面
        callback && callback(false);
      },
      fail() {},
    });
    // wx.showOptionMenu();
  });
}

// 获取微信分享title
export function getWxShareTitle(val) {
  if (val === pathInfo.home) return '首页';
  if (val === pathInfo.position) return '职位列表';
  if (val === pathInfo.social) return '社会招聘';
  if (val === pathInfo.campus) return '校园招聘';
  if (val === pathInfo.questionSocial || val === pathInfo.questionCampus || val === pathInfo.questionAnnouncement)
    return '常见问题';
  if (val === pathInfo.beidou) return '北斗计划';
  if (val === pathInfo.qihang) return '零售启航计划';
  if (val === pathInfo.workInMeituan) return '了解美团';
  return null;
}

// 设置微信分享信息
export function setWxShareInfo(title, link = window.location.href) {
  onMenuShareConfig({
    title,
    link,
    imgUrl: 'https://s3plus.meituan.net/zhaopin-official-website-mobile-prod/share/share.png',
    desc: `一起成长，一起更好！`,
  });
}
